module.exports = __webpack_public_path__ + "static/media/shiraz_package.fe470873.jpg";